export const msalConfig = {
  auth: {
    clientId: "d33ef119-7a09-41de-9957-16402ec1b2e5", 
    authority: "https://login.microsoftonline.com/0c329fd7-b7e2-4ccd-9cff-e8de618a0d90", 
    // UPDATED: Now pointing to your CloudFront URL
    redirectUri: "https://d2kgf08yllap27.cloudfront.net", 
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"], 
};